<template>
  <div>
    <AppHeader />

    <section class="hero hero-eastern reviews-hero">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>Отзывы учеников</h1>
          <p>Реальные истории студентов школы «Мама, я в Китае»</p>
        </div>
      </div>
    </section>

    <UISection :narrow="true" class="reviews-section">
      <template #default>
        <div class="state" v-if="loading">Загружаем отзывы…</div>
        <div class="state error" v-else-if="error">{{ error }}</div>
        <div v-else-if="!reviews.length" class="state">Пока нет опубликованных отзывов.</div>
        <div v-else class="reviews-grid">
          <UICard class="review-card" v-for="review in reviews" :key="review.id">
            <div class="review-header">
              <span class="date">{{ formatDate(review.created_at) }}</span>
            </div>
            <div class="review-body">
              <div v-if="review.media_url" class="media-preview" @click="openMedia(review.media_url, review.media_type)">
                <img v-if="review.media_type === 'image'" :src="review.media_url" alt="Превью" />
                <div v-else class="video-preview">
                  <video :src="review.media_url" muted></video>
                  <span class="play-icon">▶</span>
                </div>
              </div>
              <div class="review-text">{{ review.text }}</div>
            </div>
            <div class="review-meta">
              <div class="review-author">{{ review.student_name }}</div>
              <div v-if="review.teacher_name" class="teacher">Преподаватель: {{ review.teacher_name }}</div>
            </div>
          </UICard>
        </div>
      </template>
    </UISection>

    <section class="cta-section">
      <div class="container">
        <h2>Хотите, чтобы следующий отзыв был вашим?</h2>
        <p>Запишитесь на бесплатный пробный урок и познакомьтесь с преподавателем</p>
        <UIButton to="/contacts#contact-methods">Записаться на урок</UIButton>
      </div>
    </section>

    <ReviewMediaModal
      v-if="modal.visible"
      :src="modal.src"
      :type="modal.type"
      @close="closeModal"
    />

    <UIFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import UISection from '@/components/ui/UISection.vue'
import UICard from '@/components/ui/UICard.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UIFooter from '@/components/ui/UIFooter.vue'
import ReviewMediaModal from '@/components/ui/ReviewMediaModal.vue'
import axios from 'axios'

const api = axios.create({
  baseURL: '/api/v1'
})

export default {
  name: 'ReviewsPage',
  components: {
    AppHeader,
    UISection,
    UICard,
    UIButton,
    UIFooter,
    ReviewMediaModal
  },
  data() {
    return {
      reviews: [],
      loading: false,
      error: '',
      modal: {
        visible: false,
        src: '',
        type: 'image'
      }
    }
  },
  created() {
    this.loadReviews()
  },
  methods: {
    async loadReviews() {
      this.loading = true
      this.error = ''
      try {
        const { data } = await api.get('/public/reviews')
        this.reviews = data || []
      } catch (err) {
        this.error = err.response?.data?.detail || 'Не удалось загрузить отзывы'
      } finally {
        this.loading = false
      }
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      })
    },
    openMedia(src, type) {
      this.modal = {
        visible: true,
        src,
        type: type || 'image'
      }
    },
    closeModal() {
      this.modal.visible = false
      this.modal.src = ''
    }
  }
}
</script>

<style scoped>
/* Уменьшаем отступ от hero секции */
.reviews-hero {
  padding-bottom: 40px !important;
}

.reviews-section :deep(.section) {
  padding-top: 40px;
  padding-bottom: 80px;
}

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.review-card {
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(14px);
  border-radius: 20px;
  border: 1px solid rgba(231, 76, 60, 0.18);
  padding: 32px;
  box-shadow: 0 35px 70px -45px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.review-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.review-body {
  overflow: hidden; /* Clearfix for floated elements */
}

.media-preview {
  width: 120px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(229, 231, 235, 0.6);
  cursor: pointer;
  position: relative;
  float: left;
  margin-right: 16px;
  margin-bottom: 8px;
  transition: transform 0.2s ease;
}

.media-preview:hover {
  transform: scale(1.02);
}

.media-preview img,
.media-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-preview {
  position: relative;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.date {
  color: #64748b;
  font-size: 0.85rem;
}

.review-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #2d3748;
  margin: 0;
}

.review-meta {
  display: grid;
  gap: 6px;
  color: #2d3748;
  font-size: 0.95rem;
}

.review-author {
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #e74c3c;
  font-size: 0.8rem;
}

.teacher {
  font-weight: 500;
  color: #475569;
}


.state {
  text-align: center;
  color: #475569;
  padding: 24px;
}

.state.error {
  color: #c0392b;
}

@media (max-width: 768px) {
  .media-preview {
    float: none;
    margin-right: 0;
    margin-bottom: 12px;
    width: 100px;
    height: 70px;
  }
  
  .review-body {
    text-align: center;
  }
}
</style>
